import { Fragment } from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import { textColorDetail, textDataColors } from '../../../../Data/Ui-Kits/HelperClasses/HelperClassesData'
import { TextColors } from '../../../../utils/Constant'
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const TextColorsCart = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={TextColors} span={textColorDetail} />
        <CardBody>
          <div className="helper-common-box"></div>
          <div className="font-primary">This is a <strong>font-primary</strong> text used class as .font-primary</div>
          {textDataColors.map((item, index) => (
            <Fragment key={index}>
              <div className="helper-common-box"></div>
              <div className={item} key={index}>This is a <strong>{item}</strong> text used class as .{item}</div>
            </Fragment>
          ))}
        </CardBody>
      </Card>
    </Col>
  )
}

export default TextColorsCart